import http from './httpService';
/*global API */
const statisticsEndpoint = `${API}/api/Statistics`;

export function getStatistics(MineOrAllSelected) {
  MineOrAllSelected = '1';
  return http.get(statisticsEndpoint, { params: { MineOrAllSelected } });
}

export function getUserActions(params) {
  return http.get(statisticsEndpoint + '/GetUserActions', {
    params: {
      userId: params.userId,
      PageNumber: params.PageNumber,
      PageSize: params.PageSize,
    },
  });
}
